export default {
    props: {
        product: {
            required: true,
            type: Object
        },
        combiProduct: {
            required: false,
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            currentQuantity: 1,
            feedbackMessage: null,
            isLoading: false,
            errorMessage: null,
        }
    },
    methods: {
        addToCart() {
            if (!this.isLoading) {
                this.isLoading = true;
                this.errorMessage = null;
                this.feedbackMessage = null;

                let payload = {};
                payload.product_id = this.product.id;
                payload.quantity = this.currentQuantity;
                if(this.combiProduct){
                    payload.combi_product_id = this.combiProduct.id;
                }
                this.$store.dispatch('cart/addItem', payload)
                    .then(response => {
                        if(response.data.error === 1) {
                            this.errorMessage = response.data.message;
                            this.feedbackMessage = null;
                        }
                        else {
                            this.feedbackMessage = response.data.message;
                            this.afterSuccessFullSubmission();
                        }
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        this.isLoading = false;
                        this.onError();
                    });
            }
        },
        missingProductId() {
            // Abstract, for components...
        },
        afterSuccessFullSubmission() {
            if(window.seo_enabled === 1) {
                window.dataLayer.push({ecommerce: null});
                window.dataLayer.push({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'items': [{
                            'item_id': this.product.code,
                            'item_name': this.product.title,
                            'price': this.product.price.replace(',', '.'),
                            'quantity': '1'
                        }]
                    }
                });
            }
        },
        onError() {
            // Abstract, for components...
        }
    },
    created() {
        //
    }
}
